import type { ReactNode } from 'react';

interface ScoreRingProps {
  /** 0-100. */
  pct: number;
  size: number;
  fontSize: number;
  children?: ReactNode;
}

/**
 * The conic-gradient progress ring used for match scores and the Get Found
 * score. Transcribed from the mockup's `ring(pct, size, fs)` helper — same
 * conic-gradient formula (deg = pct * 3.6), same inset "hole" (size - 9).
 */
export function ScoreRing({ pct, size, fontSize, children }: ScoreRingProps) {
  const deg = pct * 3.6;
  const outer: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: `conic-gradient(var(--tl-accent) ${deg}deg, var(--tl-surf2) 0)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  };
  const inner: React.CSSProperties = {
    width: size - 9,
    height: size - 9,
    borderRadius: '50%',
    background: 'var(--tl-surf)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'var(--tl-serif)',
    fontSize,
    color: 'var(--tl-ink)',
    fontWeight: 500,
  };
  return (
    <div style={outer}>
      <div style={inner}>{children ?? pct}</div>
    </div>
  );
}
